<template></template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            show : false,
        }
    },
    methods: {
        toggle() {
            this.show = !this.show;
        }
    },
    watch: {
        show() {
            if (this.show) {
                this.eventHub.$emit('openListItem', this.id);
                jQuery(this.$refs.content).slideDown();
            } else {
                jQuery(this.$refs.content).slideUp();
            }
        }
    },
    mounted() {
        this.eventHub.$on('openListItem', id => {
            // if we open another, we want to close this one
            if (id != this.id) {
                this.show = false;
            }
        });
    },
}
</script>
